import * as Sentry from '@sentry/react';
import { isUndefined } from 'lodash';
import config from 'config';

export const initializeSentry = () => {
  const sandboxId = config.get('sandboxId');

  if (isUndefined(sandboxId) || sandboxId === 'local-machine') {
    // eslint-disable-next-line no-console
    console.warn('Disabling sentry for local or unknown environment');

    return;
  }

  const isProd = sandboxId === 'production';

  Sentry.init({
    dsn: 'https://625cb6c32f977add731e569b6f3bb8f1@o4506723807526912.ingest.sentry.io/4506785264238592',
    environment: sandboxId,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        networkDetailAllowUrls: [''],
      }),
    ],
    normalizeDepth: 10,
    // Performance Monitoring
    tracesSampleRate: isProd ? 1.0 : 0.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: isProd ? 1.0 : 0.0, // Capture 100% of sessions in prod, none in lower envs
    replaysOnErrorSampleRate: isProd ? 1.0 : 0.0, // Capture 100% of error in prod, none in lower envs.
  });
};

export enum SentryIssueReportType {
  softError = 'soft-error',
  manualError = 'manual-error',
}

export const SENTRY_CONSTANTS = {
  SENTRY_ISSUE_REPORT_TYPE_TAG_KEY: 'issue-report-type',
};
